export default "__VITE_PUBLIC_ASSET__06a2d7c4__"